"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RateLimitedWorkerDecoratorFactory = void 0;
const RateLimitingWorkerDecorator_1 = require("./RateLimitingWorkerDecorator");
class RateLimitedWorkerDecoratorFactory {
    constructor(rateLimiter, delegateFactory) {
        this.rateLimiter = rateLimiter;
        this.delegateFactory = delegateFactory;
    }
    createWorker(RequestTask) {
        const worker = this.delegateFactory.createWorker(RequestTask);
        return new RateLimitingWorkerDecorator_1.RateLimitingWorkerDecorator(this.rateLimiter, worker);
    }
}
exports.RateLimitedWorkerDecoratorFactory = RateLimitedWorkerDecoratorFactory;
